import React, {useEffect, useState} from 'react';

// custom components
import { Text } from '../../atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// utils
import { Colors } from '../../../styles';

const RequestHeader = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <div>
            <table class="table" style={{ }}>
                <thead style={{}}>
                    <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                        <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Parameter</th>
                        <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>Authorization</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'Includes your JWT access token e.g Bearer <token>'}</Text.TableBody></td>
                    </tr>
                    {
                        props.contentType && 
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>Content-type</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>application/json</Text.TableBody></td>
                    </tr>
                    }       
                </tbody>
            </table>
        </div>
    )
};

export default RequestHeader;